const EditProfileStyles = {
    container: {
        padding: '2rem',
        maxWidth: '800px',
        margin: 'auto',
        backgroundColor: '#f9f9f9',
        borderRadius: '10px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    },
    title: {
        marginBottom: '2rem',
        textAlign: 'center',
        color: '#333',
    },
    textField: {
        marginBottom: '1.5rem',
    },
    submitButton: {
        marginTop: '1rem',
        padding: '0.75rem 1.5rem',
        borderRadius: '8px',
        fontWeight: 'bold',
    },
};

export default EditProfileStyles;
